import { render, staticRenderFns } from "./q-pop-read-tips.vue?vue&type=template&id=7aed3359&scoped=true&"
import script from "./q-pop-read-tips.vue?vue&type=script&lang=js&"
export * from "./q-pop-read-tips.vue?vue&type=script&lang=js&"
import style0 from "./q-pop-read-tips.vue?vue&type=style&index=0&id=7aed3359&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aed3359",
  null
  
)

export default component.exports